export const heroSlides = [
  {
    id: "h1",
    mediaId: "m1",
    title: "流浪地球3",
    kicker: "焦点推荐 · 正在热映",
    subtitle: "行星发动机最终启动，人类文明的最后一搏",
    tags: ["科幻", "灾难", "2025"],
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20blockbuster%20banner%2C%20astronauts%20walking%20across%20a%20vast%20icy%20alien%20plain%20toward%20a%20giant%20glowing%20ark%20ship%2C%20epic%20scale%2C%20cold%20blue%20and%20warm%20amber%20light%2C%20dramatic%20widescreen%20composition&width=1600&height=900&seq=hero-91peach-1&orientation=landscape",
  },
  {
    id: "h2",
    mediaId: "t2",
    title: "长夜未央",
    kicker: "年度巨制 · 全网热播",
    subtitle: "一场关于权谋与深情的漫长博弈",
    tags: ["古装", "权谋", "2025"],
    image:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20banner%2C%20couple%20silhouetted%20on%20a%20rooftop%20overlooking%20a%20glittering%20city%20skyline%20at%20dusk%2C%20warm%20peach%20and%20violet%20sky%2C%20cinematic%20widescreen%20mood%2C%20soft%20bokeh&width=1600&height=900&seq=hero-91peach-2&orientation=landscape",
  },
  {
    id: "h3",
    mediaId: "m7",
    title: "迷雾追凶",
    kicker: "口碑爆款 · 高分悬疑",
    subtitle: "每个人都在说谎，真相藏在十年之前",
    tags: ["悬疑", "犯罪", "2025"],
    image:
      "https://readdy.ai/api/search-image?query=mystery%20thriller%20banner%2C%20detective%20walking%20down%20a%20narrow%20foggy%20alley%20lit%20by%20a%20single%20flickering%20lamp%2C%20deep%20teal%20shadows%2C%20tense%20cinematic%20widescreen%20composition%2C%20film%20noir%20mood&width=1600&height=900&seq=hero-91peach-3&orientation=landscape",
  },
  {
    id: "h4",
    mediaId: "t4",
    title: "山海图志",
    kicker: "东方奇幻 · 视觉盛宴",
    subtitle: "当古老传说，重新降临人间",
    tags: ["奇幻", "冒险", "2025"],
    image:
      "https://readdy.ai/api/search-image?query=fantasy%20epic%20banner%2C%20magnificent%20ancient%20chinese%20city%20floating%20among%20clouds%20with%20dragons%20circling%20the%20pagodas%2C%20golden%20hour%20glow%2C%20grand%20cinematic%20widescreen%20key%20art&width=1600&height=900&seq=hero-91peach-4&orientation=landscape",
  },
];

export const quickEntries = [
  {
    key: "movie",
    title: "电影",
    desc: "全球佳片 · 院线新作",
    count: "1,286 部",
    icon: "ri-film-line",
  },
  {
    key: "tvshow",
    title: "电视剧",
    desc: "热播剧集 · 完结好剧",
    count: "968 部",
    icon: "ri-tv-2-line",
  },
  {
    key: "show",
    title: "综艺",
    desc: "真人秀 · 音乐 · 纪实",
    count: "512 档",
    icon: "ri-mic-line",
  },
  {
    key: "news",
    title: "资讯",
    desc: "行业动态 · 影视快讯",
    count: "每日更新",
    icon: "ri-newspaper-line",
  },
];

export const topics = [
  {
    id: "tp1",
    title: "年度热映",
    desc: "2025 年度口碑与热度双收的院线佳作精选合集",
    count: "28 部作品",
    cover:
      "https://readdy.ai/api/search-image?query=best%20of%20year%20movie%20collection%20cover%2C%20collage%20of%20glowing%20movie%20scenes%20inside%20a%20golden%20frame%2C%20warm%20cinematic%20tone%2C%20editorial%20key%20art&width=800&height=450&seq=topic-91peach-1&orientation=landscape",
    query: "年度热映",
  },
  {
    id: "tp2",
    title: "经典必看",
    desc: "跨越年代的高分经典，值得一次又一次重温",
    count: "36 部作品",
    cover:
      "https://readdy.ai/api/search-image?query=classic%20must%20watch%20collection%20cover%2C%20vintage%20cinema%20curtain%20with%20classic%20film%20projector%20light%20beams%2C%20nostalgic%20warm%20sepia%20tones%2C%20editorial%20key%20art&width=800&height=450&seq=topic-91peach-2&orientation=landscape",
    query: "经典必看",
  },
  {
    id: "tp3",
    title: "高分剧集",
    desc: "口碑炸裂的电视剧与综艺，追完还想再刷一遍",
    count: "42 部作品",
    cover:
      "https://readdy.ai/api/search-image?query=high%20rated%20drama%20collection%20cover%2C%20stacked%20tv%20series%20posters%20with%20a%20remote%20control%20and%20popcorn%20under%20cozy%20light%2C%20warm%20inviting%20tones%2C%20editorial%20key%20art&width=800&height=450&seq=topic-91peach-3&orientation=landscape",
    query: "高分剧集",
  },
];